import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <React.Fragment>
    <path fill="none" d="M0 0h24v24H0z" />
    <path
      d="M11.25 20.25C13.2468 20.2496 15.1862 19.5811 16.7591 18.351L21.7046 23.2965L23.2954 21.7058L18.3499 16.7603C19.5806 15.1871 20.2495 13.2474 20.25 11.25C20.25 6.28763 16.2124 2.25 11.25 2.25C6.28763 2.25 2.25 6.28763 2.25 11.25C2.25 16.2124 6.28763 20.25 11.25 20.25ZM11.25 4.5C14.9726 4.5 18 7.52738 18 11.25C18 14.9726 14.9726 18 11.25 18C7.52738 18 4.5 14.9726 4.5 11.25C4.5 7.52738 7.52738 4.5 11.25 4.5Z"
      fill="inherit"
    />
    <path
      d="M12.8385 9.65923C13.2649 10.0867 13.5 10.6515 13.5 11.25H15.75C15.751 10.6587 15.6348 10.0731 15.4081 9.52702C15.1814 8.98094 14.8487 8.4852 14.4292 8.06847C12.726 6.36747 9.77287 6.36747 8.07075 8.06847L9.65925 9.66148C10.5142 8.80873 11.988 8.81098 12.8385 9.65923Z"
      fill="inherit"
    />
  </React.Fragment>,
  "NewIcon"
);
